export function formatEstimate(mins) {
  if (!mins) {
    return '';
  }

  const totalMinutes = Math.abs(mins);
  const minutes = totalMinutes % 60;
  const totalHour = Math.floor(totalMinutes / 60);
  const days = Math.floor(totalHour / 24);
  const hours = totalHour % 24;

  if (days) {
    return `Takes about ${days > 1 ? days : 'a'} day${days > 1 ? 's' : ''}`;
  }
  if (hours) {
    return `Takes about ${hours > 1 ? hours : 'an'} hour${hours > 1 ? 's' : ''}`;
  }
  if (minutes) {
    return `Takes about ${minutes > 1 ? minutes : 'a'} minute${minutes > 1 ? 's' : ''}`;
  }

  return '';
}
